<form>
   <div class="sam-form-row">
      <label>{{ 'common.audio_settings.titles.ringer_device' | translate }}</label>
      <samweb-audio-device-selector deviceType="ringer"></samweb-audio-device-selector>
   </div>

   <div class="sam-form-row">
      <label>{{ 'common.audio_settings.titles.output_device' | translate }}</label>
      <samweb-audio-device-selector deviceType="audiooutput"></samweb-audio-device-selector>
   </div>

   <div class="sam-form-row">
      <label>{{ 'common.audio_settings.titles.input_device' | translate }}</label>
      <samweb-audio-device-selector deviceType="audioinput"></samweb-audio-device-selector>
   </div>

   <div class="sam-form-row">
      <label>{{ 'common.audio_settings.titles.manufacturer' | translate }}</label>
      <samweb-headset-manufacturer-selector deviceType="manufacturer"></samweb-headset-manufacturer-selector>
   </div>
</form>
